import { render, staticRenderFns } from "./MyInputs.vue?vue&type=template&id=4c0fa66e&scoped=true&"
import script from "./MyInputs.vue?vue&type=script&lang=js&"
export * from "./MyInputs.vue?vue&type=script&lang=js&"
import style0 from "./MyInputs.vue?vue&type=style&index=0&id=4c0fa66e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0fa66e",
  null
  
)

export default component.exports